









import { Vue, Prop, Component } from 'vue-property-decorator'

@Component
export default class CeaseAndDesistWidget extends Vue {
  @Prop({ type: String, required: true }) readonly message!: string
}
